//'use strict';
//
import * as d3 from "d3";
// require('./scatterplot.d3');
import scatterplot from "./scatterplot.d3";

export default class ScatterplotController{

    constructor(
        $state,
        $scope,
        scatterplotService
    ){

        let vm = this;

        vm.pageTitle = "Scatterplot";

        vm.scatterplotService = scatterplotService;
        vm.cityData = vm.scatterplotService.getCityData();
        vm.zeroAxisCity = vm.scatterplotService.getCityByName("haikou");

        // console.log("DATA --- ", vm.cityData);



        vm.sPlot = scatterplot("#scatterplot")
            .w(540)
            .h(340)
            .xAxisLabel("Household Disposable Income 2016 (USD)")
            .yAxisLabel("CAGR of Total Disposable Income over 2011-2016 in constant prices(%)")
            .zeroAxis(vm.zeroAxisCity);

        d3.select("#scatterplot").datum(vm.cityData)
            .call(vm.sPlot);

        //
        // d3.select(vm.chartId).call(vm.dotPlotSingle);
        //
        //
        //
        //     $scope.$on('$locationChangeSuccess', function() {
        //         vm.rankData = vm.globalHairCareService.getRankData();
        //
        //         let arr = [vm.rankData[vm.chartIndex]]
        //         arr.push()
        //
        //
        //         vm.dotPlotSingle
        //             .data(arr)
        //             .w(120)
        //             .h(12);
        //
        //         d3.select(vm.chartId).call(vm.dotPlotSingle);
        //
        //
        //     })





        }
}

ScatterplotController.$inject = [
    "$state",
    "$scope",
    "scatterplotService"
];



// WEBPACK FOOTER //
// ./src/app/emxd-charts/scatterplot/scatterplot.controller.js